<template>
    <GMapMap ref="gMap" :center="center" :zoom="11" class="listing-map">
        <GMapMarker :clickable="true" :position="center" :icon="icon" @click="toggleMarker">
            <GMapInfoWindow :opened="showMarker">
                <h3>{{ listing.name }}</h3>

                <div class="address">
                    <hours-status :listing="listing"></hours-status>
                    {{ listing.location.line1 }}<br />
                    {{ listing.location.line2 }}
                </div>
            </GMapInfoWindow>
        </GMapMarker>
    </GMapMap>
</template>

<script>import script from './ListingMap';
    export default script;</script>
